import { CONST } from "../../CONST";

interface CountdownConfig{
    scene: Phaser.Scene,
    position: {x: number, y: number},
    maxValue: number,
    depth: number,
}

export class Countdown {
    public config: CountdownConfig;

    private countdownImage !: Phaser.GameObjects.Image; 
    private maskShape !: Phaser.GameObjects.Graphics;
    private countdownStartX = 0;
    private countdownMoveX = 0;

    constructor(config: CountdownConfig){
        this.config = config;
        this.createImages();
        this.displayScore(0);
    }

    private createImages(){
        this.config.scene.add.image(this.config.position.x, this.config.position.y, CONST.DISTRACTION.COUNTDOWN_1).setDepth(this.config.depth); //bg
        this.config.scene.add.image(this.config.position.x, this.config.position.y, CONST.DISTRACTION.COUNTDOWN_2).setDepth(this.config.depth+1); //white bg

        this.countdownImage = this.config.scene.add.image(this.config.position.x, this.config.position.y, CONST.DISTRACTION.COUNTDOWN_3).setDepth(this.config.depth+2);
    
        this.maskShape = this.config.scene.add.graphics().fillStyle(0xffffff, 0).beginPath().fillRect(this.countdownImage.getTopLeft().x, 0, this.countdownImage.displayWidth, 500).setDepth(this.config.depth+3);
        this.countdownStartX = this.maskShape.x;
        this.countdownMoveX = this.countdownImage.displayWidth;

          var mask = this.maskShape.createGeometryMask();
          this.countdownImage.setMask(mask);
    }

    public displayScore(score: number){
        let percentage = Phaser.Math.Clamp(score/this.config.maxValue, 0, 1);
         this.maskShape.x = this.countdownStartX - (1-percentage) * this.countdownMoveX;
    }
}